<template>
  <b-card no-body class="mt-n2">
    <b-row class="mx-1 mt-2 mb-1">
      <b-card
        v-if="hasUserSelection"
        class="header-card"
      >
        <h4 class="mb-1">User Details</h4>
        <div class="details-row d-flex flex-row mt-2">
          <span>
            <b-icon :style="{ color: iconColors.blue }" class="mr-0-5" icon="info-square-fill"/>
            <b>User:</b>
            {{ selectedUser.userName ? selectedUser.userName : 'N/A' }}
          </span>
        </div>
      </b-card>
      <h4 class="mb-1" v-else>No User Selected</h4>
    </b-row>
    <b-row v-if="hasUserSelection" class="ml-0-5 my-1">
      <b-col>
        <div v-if="hasData">
          <b-table
            class="table-with-actions-min-height px-2"
            responsive
            striped
            outlined
            :items="userFilter"
            :fields="computedTableFields"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
          />
          <b-pagination
            v-model="currentPage"
            :total-rows="paginationTotalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-2 mx-1"
          />
        </div>
        <div v-else-if="loaded" class="mx-1 pl-1 mb-1">
          {{ $t("No Data Available") }}
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import colorPalette from '@/xvisor/constants/colorPalette';
import SecurityEventBus from '@/xvisor/bus/SecurityEventBus';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedUser: null,
      userDetails: [],
      loaded: false,
      currentPage: 1,
      perPage: 10,
      options: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 15, text: '15' },
      ],
      filter: null,
      filteredLength: null,
      tableFields: [
        { key: 'deviceName', label: 'Device', sortable: true },
        { key: 'processName', label: 'Process', sortable: true },
        { key: 'executionCount', label: 'Count', sortable: true },
      ],
      iconColors: {
        blue: colorPalette.teal,
        purple: colorPalette.purple,
      },
    };
  },
  computed: {
    hasUserSelection() {
      return this.selectedUser !== null && this.selectedUser !== undefined;
    },
    hasData() {
      return this.loaded && this.userDetails && this.userDetails.length > 0;
    },
    paginationTotalRows() {
      if (this.filter) return this.filteredLength;
      return this.userDetails.length;
    },
    computedTableFields() {
      return this.tableFields;
    },
    userFilter() {
      return this.userDetails;
    },
  },
  watch: {
    timeRange() {
      this.selectedUser = null;
    },
  },
  created() {
    SecurityEventBus.$on('update-selected-user', (curUser) => {
      this.selectedUser = curUser;
      this.httpGet();
    });
  },
  methods: {
    httpGet() {
      const detailEndpoint = `/security/endpoint/${this.selectedUser.userName}/userdetails.json`;

      this.loaded = false;
      this.$http
        .get(detailEndpoint, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
          },
        })
        .then((response) => { this.userDetails = response.data; })
        .finally(() => { this.loaded = true; });
    },
    onFiltered(filteredItems) {
      this.filteredLength = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
.header-card {
  width: 100%;
}
.header-card>.card-body {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.details-row {
  gap: 5rem;
}
</style>
